import {ComponentRegistry} from '../../components/component-registry';
import {DataApi} from '../../api/data-api/data-api';
import {AbstractFilter} from '../abstract-filter';
import {PluginFilter, PluginSettings} from '../abstract-data-api-plugin';

interface NewsFilter extends PluginFilter {
}

interface NewsSettings extends PluginSettings {
}

export {NewsFilter, NewsSettings};

/**
 * News filter.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Filter extends AbstractFilter<NewsFilter, NewsSettings> {
  constructor(container: HTMLElement) {
    super(container, 'news', {
      category: 0
    } as NewsFilter);
    DataApi.instance.newsEndpoint.distinctValues(this.settings)
      .then(response => {
        const template = require('../../handlebars/templates/news/filter.handlebars');
        const html = template({
          distinctValues: response,
          filter: this.filter
        });
        this.update(html);
        this.initializeResult();
        ComponentRegistry.add('news-filter', this);
      })
      .catch(e => {
        this.error(e);
      });
  }
}
